import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "EDU_SCHOL_TT",
  title: defineMessage({
    id: "fig.finance.aid.EDU_SCHOL_TT.title",
    defaultMessage: ``,
  }),
  caption: defineMessage({
    id: "fig.finance.aid.EDU_SCHOL_TT.caption",
    defaultMessage: ``,
  }),
  source: defineMessage({
    id: "fig.finance.aid.EDU_SCHOL_TT.source",
    defaultMessage: ``,
  }),
};
